import { useState, useEffect } from 'react'
import './App.css';
import './assets/style/colormode.css'
import { Routes, Route } from 'react-router-dom'

// // views
import Navigation from './components/Navbar'
import Home from './views/Home'
import About from './views/About'
import Services from './views/Services'
import Projects from './views/Projects'
import Contact from './views/Contact'

const Routing = () => {
  return (
    <>
      <Routes>
        <Route exact path='/' element={<Home />}></Route>
        <Route exact path='/about' element={<About />}></Route>
        <Route exact path='/services' element={<Services />}></Route>
        <Route exact path='/projects' element={<Projects />}></Route>
        <Route exact path='/contact' element={<Contact />}></Route>
      </Routes>
    </>
  )
}

function App() {
  const [colormode, setColormode] = useState('mode1');
  const [mainview, setMainview] = useState()

  useEffect(() => {
    let height = window.innerHeight;
    // console.log(height)
    setMainview(height - 76);
    // console.log(mainview)

    // cursor
    window.addEventListener('mousemove', (e) => {
      let xcord = e.clientX;
      let ycord = e.clientY;
      // console.log(xcord + ',' + ycord)

      let dots = document.querySelectorAll('.dots');
      dots.forEach(dot => {
        dot.style.left = xcord + 1 + 'px';
        dot.style.top = ycord + 1 + 'px';
      })
    })
    //cursor-end

  }, [colormode, mainview])
  return (
    <>
      <section className={`main-view ${colormode}`} >
        <div className='container-fluid text-light'>
          <div className="row px-5 main-row">
            <div className="col-sm-12 col-md-1 tm-color">
              <div className="box cs1" onClick={() => { setColormode('mode1') }}></div>
              <div className="box cs2" onClick={() => { setColormode('mode2') }}></div>
              <div className="box cs3" onClick={() => { setColormode('mode3') }}></div>
            </div>
            <div className="col-sm-12 col-md-10 tm-content p-0" style={{ 'height': `${mainview}px` }}><Routing /></div>
            <div className="col-sm-12 col-md-1 tm-menu p-0"><Navigation /></div>
          </div>
        </div>
      </section>

      <section className={`cursor-follow ${colormode}`} id='cursor'>
        <span className="c1 dots"></span>
        <span className="c2 dots"></span>
        <span className="c3 dots"></span>
        <span className="c4 dots"></span>
        <span className="c5 dots"></span>
        <span className="c6 dots"></span>
        <span className="c7 dots"></span>
        <span className="c8 dots"></span>
        <span className="c9 dots"></span>
        <span className="c10 dots"></span>
        <span className="c11 dots"></span>
        <span className="c12 dots"></span>
        <span className="c13 dots"></span>
        <span className="c14 dots"></span>
        <span className="c15 dots"></span>
        <span className="c16 dots"></span>
        <span className="c17 dots"></span>
        <span className="c18 dots"></span>
        <span className="c19 dots"></span>
        <span className="c20 dots"></span>
      </section>


    </>
  );
}

export default App;
